var _defs, _g, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAleo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 564.8 158.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.51,
    y1: 137.31,
    x2: 104.7,
    y2: -4.11,
    gradientTransform: "translate(-31.8 36.91) rotate(-29.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#144df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#03c3f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 151.74,
    y1: 139.2,
    x2: 73.69,
    y2: 1.23,
    gradientTransform: "translate(181.61 205.88) rotate(-150.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01e8ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#01dff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#00c3f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.25,125.43c-13.3-36.44-26.61-72.87-39.89-109.31-.21-.59-.51-.69-1.06-.69-7.17,.01-14.34,.01-21.52,0-.62,0-.89,.19-1.1,.77-2.35,6.51-4.73,13.01-7.1,19.52-10.87,29.76-21.75,59.53-32.61,89.29-.12,.34-.22,.67-.34,1.04,.22,.03,.34,.06,.44,.06,8.38,0,16.74,0,25.12,.02,.63,0,.76-.34,.91-.79,1.57-4.64,3.14-9.29,4.72-13.93,1.14-3.34,2.28-6.68,3.44-10.08h.78c10.94,0,21.89,0,32.83-.01,.62,0,.89,.19,1.09,.78,2.63,7.68,5.3,15.36,7.93,23.04,.25,.72,.54,1.01,1.36,1.01,8.06-.04,16.11-.03,24.18-.03h1.06c-.11-.32-.16-.51-.23-.69Zm-64.91-41.8c4.38-12.93,8.74-25.8,13.11-38.67,.06,0,.11,0,.18,.01,4.25,12.86,8.51,25.71,12.79,38.66h-26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.13,77.67c-2.89-16.49-12.25-27.56-28.17-32.82-8.53-2.81-17.34-2.87-26.08-1.01-11.39,2.42-20.47,8.42-26.51,18.51-5.81,9.69-7.57,20.24-5.65,31.31,2.14,12.31,8.6,21.79,19.49,28.06,10.31,5.95,21.47,6.9,33.01,5.23,8.68-1.25,16.15-5.11,22.71-10.81,4.19-3.64,7.63-7.86,9.51-13.17,.35-.99,.61-2,.94-3.13h-1.09c-4,0-8,0-12,0-3.49,0-6.97,.02-10.45,.07-.31,0-.79,.17-.89,.4-1.5,3.4-4.14,5.63-7.43,7.12-7.75,3.49-15.19,3.26-22.06-2.15-3.93-3.09-5.45-7.43-5.87-12.34h60.48c.09-.42,.16-.73,.2-1.04,.6-4.75,.69-9.51-.14-14.24Zm-60.93-.27c.51-8.16,6.42-17.04,18.06-16.74,10.58,.28,16.56,8.57,16.94,16.74h-34.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.07,77.65c-2.64-14.98-10.93-25.73-25.04-31.56-11.05-4.56-22.49-4.62-33.78-.95-10.75,3.49-18.95,10.3-23.85,20.64-5.02,10.6-5.7,21.63-2.37,32.84,3.37,11.33,10.48,19.57,21.15,24.7,6.54,3.14,13.48,4.34,21.77,4.34,3,.01,7.07-.32,11.05-1.31,11.55-2.89,20.66-9.14,26.43-19.7,4.97-9.08,6.42-18.85,4.64-29.01Zm-29.78,22.35c-7.32,9.61-22.91,8.91-29.04-3.02-2.29-4.46-2.83-9.23-2.46-14.14,.33-4.33,1.64-8.35,4.23-11.85,7.5-10.14,22.5-9.24,28.91,1.71,2.26,3.85,3.02,8.08,3.04,13.12,0,4.79-1.34,9.81-4.67,14.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 340.17,
    y: 12.37,
    width: 24.88,
    height: 113.71
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.65,
    y: -8.29,
    width: 45.78,
    height: 174.88,
    rx: 22.89,
    ry: 22.89,
    transform: "translate(45.81 -16.58) rotate(29.36)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 94.88,
    y: -8.29,
    width: 45.78,
    height: 174.88,
    rx: 22.89,
    ry: 22.89,
    transform: "translate(259.22 90.4) rotate(150.64)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAleo);
export default __webpack_public_path__ + "static/media/aleo.a463fda8e005b0e9311e55f62572f6eb.svg";
export { ForwardRef as ReactComponent };